import { AbsoluteFill, Sequence, useVideoConfig } from "remotion";
import { EndCta } from "../shared/EndCta";
import { FourierFilm } from "./FourierHeart";
import { KoiDetailDrawing } from "./KoiDetailDrawing";
import { koiModel } from "./koiModel";
import { koiTheme } from "./koiTheme";

/** Penguin-style circle stages; every interior stroke then grows from the left panel. */
export const FourierKoi = () => {
  const { fps } = useVideoConfig();
  return (
    <AbsoluteFill>
      <FourierFilm
        model={koiModel}
        targetLabel="TRACED KOI"
        centerFinal
        colors={koiTheme.colors}
        timing={koiTheme.timing}
        skipIntroCopy
        flatStyle
        finalScale={440}
        outroTextDelay={5.15}
        outroText={["THIS IS", "FOURIER KOI"]}
      />
      <KoiDetailDrawing />
      <Sequence from={Math.round(13.35 * fps)} durationInFrames={Math.round(1.5 * fps)} premountFor={fps}>
        <EndCta variant="minimal" accentColor="#42BACF" likeColor="#68C5D4" />
      </Sequence>
    </AbsoluteFill>
  );
};
